import { Subject } from "rxjs";
import { switchMap } from "rxjs/operators";
import store from "../../../../app/store";
import { streamChat } from "../../../../api/chatbotApiClient";

const _orgClientId = () => {
  const state = store.getState();
  return state?.orgReducer?.selectedFI?.orgClientId;
};

export const userMessage$ = new Subject();

export const botResponse$ = userMessage$.pipe(
  // switchMap((message) => _post(`${_orgClientId()}/chat`, message)),
  switchMap((message) => streamChat(`${_orgClientId()}/chat`, message)),
);
